import React from 'react'
import * as d3 from 'd3'

interface Props {
    from: [number,number]
    to: [number,number]
    strokeColor: string
    strokeWidth: number
    strokeOpacity?: number
}

const D3Line: React.FC<Props> = ({from, to, strokeColor, strokeWidth, strokeOpacity}) => {

    const lineCoords = d3.line()([from, to])!;

    return (
        <path 
            d={lineCoords} 
            stroke={strokeColor}
            strokeWidth={strokeWidth}
            strokeOpacity={strokeOpacity || 1}
            pointerEvents={'none'}
        />
    )
}

export default D3Line
